// TODO: Move this hook to @domain package
import {ApiClient} from '@hconnect/apiclient'
import {useQuery} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {WorkOrderDto} from '../../types'

const QueryKey = 'work-orders'

type Params = {
  plantId: string
  notificationId: string
}

export const useSapWorkOrders = ({plantId, notificationId}: Params) => {
  return useQuery<WorkOrderDto, AxiosError>({
    queryKey: [QueryKey, plantId, notificationId],
    queryFn: async () => {
      const {data} = await ApiClient.axiosInstance.get<WorkOrderDto>(
        `/work-orders/${plantId}/work-order-by-notification-id/${notificationId}`
      )
      return data
    },
    refetchOnWindowFocus: false
  })
}
